import { createMiddleware } from "@tanstack/react-start";
import { getAuthSnapshot } from "@/lib/auth-snapshot";

/**
 * يضيف جلسة AuthContext الحالية إلى server functions بلا إعادة طلب getSession.
 * هذا يمنع سباق استرجاع الجلسة الذي كان يرسل نداءً محميّاً بلا Bearer token.
 */
export const attachCurrentAuth = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    const { accessToken } = getAuthSnapshot();
    return next({
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
    });
  },
);